import React from 'react';

export interface Props {
  icon?: string;
  selected: number;
  value: number;

  onClick: (value: number) => void;
}

const Tab: React.FC<Props> = React.memo((props) => {
  const { icon, selected, value, onClick } = props;

  const active: boolean = React.useMemo(() => {
    return selected === value;
  }, [selected, value]);

  const className: string = React.useMemo(() => {
    return ['tab'].addIf(active, 'active').toClassNames();
  }, [active]);

  const iconClassName: string = React.useMemo(() => {
    return ['fa fa-lg'].addNotEmpty(icon).toClassNames();
  }, [icon]);

  const click = React.useCallback(() => {
    onClick(value);
  }, [value, onClick]);

  return (
    <div className={className} onClick={click}>
      <i className={iconClassName} />
    </div>
  );
});

Tab.defaultProps = {
  icon: ''
};
Tab.displayName = 'Tab';

export default Tab;
